// Dependencies
import React, { useState, useEffect, useRef, useCallback, useContext } from "react";

import { ReactSVG } from "react-svg";
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import { CSSTransitionProps } from "react-transition-group/CSSTransition";
import { Portal } from 'react-portal';

// Types
import { Types, Components } from '../types';

// Utils
import { WP_PLUGIN_BASE_PATH } from '../utils/config'

// Hooks
import { useDebug } from "../hooks";
 
// Components
import { MinicartContext } from "../contexts/Minicart";

const SidebarEmpty = ({ className  }: any) => {
    
    useDebug('SidebarEmpty'); 

    // Contexts
    const { itemsCount, config, translations, theme } = useContext( MinicartContext );

    const transitionProps: CSSTransitionProps = React.useMemo(() => ({
        in: itemsCount === 0,
        timeout: Number(theme.general.transition.duration.replace('ms', '')),
        unmountOnExit: true
      }), [theme.general.transition.duration, itemsCount])
    
    return (<>
      <CSSTransition {...transitionProps}>
            <div className={`${className}`}>
                <ReactSVG
                    tabIndex={0} 
                    role="button"
                    className={`${className}__icon`}
                    src={`${WP_PLUGIN_BASE_PATH}/assets/icons/${'ico-empty-cart'}.svg`}
                />
                <h1>{translations?.cartEmpty.title}</h1>
                <p>{translations?.cartEmpty.subtitle}</p>
                <a className="wooptima-button wooptima-button--cta" href={config.links?.shop?.url}>{config.links?.shop?.label}</a>
            </div>
        </CSSTransition>
    </>)
}

export default SidebarEmpty;